import { render, staticRenderFns } from "./selfHelpLoan.vue?vue&type=template&id=38a44374&scoped=true"
import script from "./selfHelpLoan.vue?vue&type=script&lang=js"
export * from "./selfHelpLoan.vue?vue&type=script&lang=js"
import style0 from "./selfHelpLoan.vue?vue&type=style&index=0&id=38a44374&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a44374",
  null
  
)

export default component.exports